import movements from './movements'
import purchases from './purchases'


export default [
    ...movements,
    ...purchases,
]